import { queryBuilder } from '@logz-pkg/opensearch-dsl';
import { IOpensearchDsl } from '@logz-pkg/models';
import { exploreSearchParamsService } from 'ui/components/Explore/router/router';
import { logsStateService } from 'ui/components/Explore/state/logs-state.service';
import { featureFlagStateService } from 'ui/state/feature-flag.state.service';

const buildLogsQuerySearchPayload = (fetchNextPage: boolean, dslFilters: IOpensearchDsl) => {
  const accounts = exploreSearchParamsService.accounts.get() ?? [];
  const allLogs = logsStateService.state.get()?.hits.hits ?? [];
  const sort = exploreSearchParamsService.sort.get() ?? [];
  const highlightQueryContainsQuery = featureFlagStateService.isFeatureEnabled('HighlightQueryContainsQuery');

  return queryBuilder.buildLogsQuerySearchPayload({
    fetchNextPage,
    dslFilters,
    highlightQueryContainsQuery,
    allLogs,
    sort,
    accounts,
  });
};

export const exploreQueryBuilder = {
  buildLogsQuerySearchPayload,
};
